/**
 * Coupon/Offer endpoints configuration
 * NOTE: These are placeholder configs - APIs do not exist yet
 */

import type { ApiEndpoint } from '../endpointsConfig'

export const couponEndpoints: ApiEndpoint[] = [
  {
    name: 'couponValidate',
    path: 'restohub-api/coupons/validate/',
    actions: ['POST'],
    tags: ['Coupon'],
  },
  {
    name: 'offer',
    path: 'restohub-api/offers/',
    actions: ['LIST'],
    tags: ['Offer'],
  },
]
